import * as selectors from './stagesets-selectors';

export const Stagesets = {
    ...selectors,
} as const;
